import { Controller } from "@hotwired/stimulus"
import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Filler } from "chart.js"

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Filler)

export default class extends Controller {
  static values = {
    series: Array,
    color: { type: String, default: "#3B5DBA" },
    max: { type: Number, default: 100 }
  }

  connect() {
    const labels = this.seriesValue.map((point) => point.date)
    const values = this.seriesValue.map((point) => point.value)
    const gradient = this.element.getContext("2d").createLinearGradient(0, 0, 0, 240)
    gradient.addColorStop(0, `${this.colorValue}33`)
    gradient.addColorStop(1, `${this.colorValue}00`)

    this.chart = new Chart(this.element, {
      type: "line",
      data: {
        labels,
        datasets: [{
          data: values,
          borderColor: this.colorValue,
          backgroundColor: gradient,
          fill: true,
          tension: 0.35,
          pointRadius: 3,
          pointHoverRadius: 5,
          pointBackgroundColor: "#FFFFFF",
          pointBorderColor: this.colorValue,
          pointBorderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: { enabled: true }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { color: "#9BA1AB", maxTicksLimit: 7 }
          },
          y: {
            min: 0,
            max: this.maxValue,
            grid: { color: "rgba(216, 222, 234, 0.7)" },
            ticks: { color: "#9BA1AB", stepSize: this.maxValue <= 10 ? 2 : 20 }
          }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
